import { Component, OnInit, OnChanges, AfterViewInit, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params, NavigationEnd, Routes, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { PrimeNG } from 'primeng/config';
import { ConfigService } from './config.service';
import { UsersService } from './users.service';
import { ForecastService } from './forecast.service';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { AuthService } from './auth.service';
import { StationTableComponent } from './station-table.component';
import { DataLayerDirective } from './data-layer.directive';
import { DashboardTemplateDirective } from './dashboard-template.directive';
import { DashboardTemplateLinkComponent } from './dashboard-template-link.component';
import { DashboardTemplateService } from './dashboard-template.service';
import { DataLayerCaQPFComponent } from './data-layer-ca-qpf.component';
import { DataLayerGeojsonCamerasComponent } from './data-layer-geojson-cameras.component';
import { DataLayerGeojsonCamerasBlueIrisComponent } from './data-layer-geojson-cameras-blueiris.component';
import { DataLayerGeojsonPointDWSComponent } from './data-layer-geojson-point-dws.component';
import { DataLayerGeojsonPointDWSRepeaterComponent } from './data-layer-geojson-point-dws-repeater.component';
import { DataLayerGeojsonPointComponent } from './data-layer-geojson-point.component';
import { DataLayerGeojsonPointFHITComponent } from './data-layer-geojson-point-fhit.component';
import { DataLayerGeojsonPolygonComponent } from './data-layer-geojson-polygon.component';
import { DataLayerGeojsonPolygonPointComponent } from './data-layer-geojson-polygon-point.component';
import { DataLayerGeojsonPointLinksComponent } from './data-layer-geojson-point-links.component';
import { DataLayerGifComponent } from './data-layer-gif.component';
import { DataLayerHighlightComponent } from './data-layer-highlight.component';
import { DataLayerKmlPointComponent } from './data-layer-kml-point.component';
import { DataLayerTMSComponent } from './data-layer-tms.component';
import { DataLayerWMSComponent } from './data-layer-wms.component';
import { DataLayerWMSTimeComponent } from './data-layer-wms-time.component';
import { DataLayerPNGRainviewerComponent } from './data-layer-png-rainviewer.component';
import { DataLayerGeojsonPointWeatherComponent } from './data-layer-geojson-point-weather.component';
import { DataLayerGeojsonPointWeatherStationComponent } from './data-layer-geojson-point-weather-station.component';
import { DataLayerGeojsonWindComponent } from './data-layer-geojson-wind.component';
import { AppConfigService } from './app-config.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DataWebServicesService } from './data-web-services.service';
import { takeWhile } from 'rxjs/operators';

// declare all javascript variables/functions defined elsewhere
declare var expandSideMenu;
// declare var ws;
declare var $;

declare var require: any;
const { version } = require('../assets/version.json');

@Component({
	selector: 'operator-app',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.css']
})

export class AppComponent implements OnInit, AfterViewInit {
	@ViewChild(StationTableComponent, {static: true, read: StationTableComponent}) stationTable: StationTableComponent;
	@ViewChild(DataLayerDirective, {static: true, read: DataLayerDirective}) dataLayerHost: DataLayerDirective;
	@ViewChild(DashboardTemplateDirective, {static: true, read: DashboardTemplateDirective}) dashboardTemplateHost: DashboardTemplateDirective;

	version = '';

	documentationUrl: string;
	private appConfigService: AppConfigService;
	private configService: ConfigService;
	private usersService: UsersService;
	mapService: MapService;
	private messageService: MessageService;
	private forecastService: ForecastService;
	private dashboardTemplateService: DashboardTemplateService;
	http: HttpClient;
	private timeIntID: any = null;
	private timeIntIDSubscription: any = null;

	clientLogo = '';
	clientWebsite = 'https://trilynx.systems';	// just a default - obviously override in configuration file
	clientLogoExists = false;

	private authService: AuthService;
	_dataLayerService: DataLayerService;
	confirmationService: ConfirmationService;
	private _route: ActivatedRoute;
	private _router: Router;
	timeLabel: String = '';
	mobileView = 992;
	toggle = true; 		// When true, the left menu is expanded.  False is collapsed.
	menuTitle = 'Display view controls';
	quickZoomVisible = true;
	errorVisible = true;
	userName = 'guest';
	userLoggedIn = false;
	displayWaitDialog = true;
	initializingOperator = true;  // set to false after initial setup of Operator application

	// The following "Count" variables are used to display a quick summary status to the user
	// for the numer of stations with the indicated novascore.
	// The error variables are used track whether an error has occured while trying to read data.
	flowError = false;
	stageError = false;
	precipCounts: any[] = [];
	stageCounts: any[] = [];
	flowCounts: any[] = [];
	fitCounts: any[] = [];
	summaryTooltip;
	numMatchingStreamflowStations = 0;
	numMatchingPrecipStations = 0;
	numMatchingStageStations = 0;
	precipError = false;
	fitError = false;
	allStationsError = false;
	floodImpactStationsError = false;
	displayFloodImpactOnMap = false;
	displayFloodImpactSummary = false;
	stationsObservable;
	allStationsGeojson;

	// disclaimer variables
	confirmationDialogDisabled = true;
	providerOrganizationText = 'Welcome';
	disclaimerText = '';
	confirmationCBTextDoNotShow = false;
	cookiesOK = false;
	confirmationDialogVisible = false;

	includeDecoration = true;

	constructor(
		appConfigService: AppConfigService,
		configService: ConfigService,
		confirmationService: ConfirmationService,
		private dataWebServices: DataWebServicesService,
		mapService: MapService,
		usersService: UsersService,
		messageService: MessageService,
		forecastService: ForecastService,
		private dataLayerService: DataLayerService,
		authService: AuthService,
		private location: Location,
		route: ActivatedRoute,
		router: Router,
		http: HttpClient,
		private primeng: PrimeNG,
		// logger: Logger,
		dashboardTemplateService: DashboardTemplateService,
		private componentFactoryResolver: ComponentFactoryResolver ) {

			// this.redirectHashURLToPath();

			this.version = 'version: ' + version;
			this.http = http;
			// this.angular2Logger = logger;

			// This allowed the application to intercept console messages.
			// this.takeOverConsole();

			this.configService = configService;
			this.confirmationService = confirmationService;
			this.configService.saveAppReference ( this );
			this.appConfigService = appConfigService;
			this.documentationUrl = this.appConfigService.getDocumentationUrl();
			this.displayFloodImpactOnMap = this.appConfigService.getDisplayFloodImpactOnMap();
			this.displayFloodImpactSummary = this.appConfigService.getDisplayFloodImpactSummary();

			this.usersService = usersService;

			this._dataLayerService = dataLayerService;
			// console.log(dataLayerService );

			this.mapService = mapService;
			// console.log(mapService);

			this.authService = authService;

			this.forecastService = forecastService;
			// this.forecastService.readForecast();

			this.dashboardTemplateService = dashboardTemplateService;

			this._route = route;
			this._router = router;

			// watch the includeDecoration value in the config service
			this.configService.includeDecorationSubject.subscribe( includeDecoration => {
				//console.log("Setting includeDecoration to " + includeDecoration);
				//this.includeDecoration = includeDecoration;
			})

			// reflect the value of the config service displayWaitDialog here
			this.configService.displayWaitDialogObservable.subscribe( displayWaitDialog => {
				this.displayWaitDialog = displayWaitDialog;
			})

			// this.attachEvents();

			// This section sets up the event handler for the dynamically created map layers.
			// It's created for any elements of class dynamicBaseLyaer before the layers are even read in.
			//
			// "this" must be saved as "self" because once inside the anonymous function, "this" becomes the label rather than app.component.ts.
			//
			const self = this;
			$(document).on('click', '.dynamicBaseLayer', function () {
				// console.log(this.id);
				// remove the current map layer
				self.mapService.map.removeLayer(self.mapService.activeTileLayer);

				// display newly clicked map layer.  Call bringToBack to assist layers such as Radar stay visible.
				self.mapService.baseMaps[this.id].addTo(self.mapService.map).bringToBack();
			});


			// If the user clicks on the "Map" anchor, the router is activated to show the map.
			// However, the Map menu should expand.
			// see http://stackoverflow.com/questions/35912932/angular-2-router-event-listener
			// http://stackoverflow.com/questions/33520043/how-to-detect-route-change-in-angular-2
			this._router.events.subscribe ( (event) => {
				// only intercept NavigationEnd events
				if ( event instanceof NavigationEnd) {
					// console.log(event.url);

					// if the station table, station dashboard, or other router links add submenu items,
					// call hide on all of them, then expand on the desired one.
					$('#mapCollapse').collapse('hide');
					// Moved because "hide" followed by "show" behaved like "toggle".
					// Doesn't make sense.
					// $('#dashboardTemplateCollapse').collapse("hide");

					// now show the desired GUI parts based on current route
					if (event.url.startsWith( '/map' )) {
						// map route is active
						//
						// show the expanded map submenu
						$('#mapCollapse').collapse('show');
						$('#dashboardTemplateCollapse').collapse('hide');

						// quick zoom should be visible since it makes sense when the map route is active
						this.setQuickZoomVisibility(true);
					} else if (event.url.includes( '/dashboardTemplate' )) {
						// dashboard template route is active
						//
						// show the expanded dashboard template submenu
						// console.log("Opening template list");
						$('#dashboardTemplateCollapse').collapse('show');
					} else {
						// currently, no other routes have submenus like map
						// so the only thing to do is hide the quick zoom components
						this.setQuickZoomVisibility(false);
						$('#dashboardTemplateCollapse').collapse('hide');
					}
				}
			});

			// listen for when all stations have been successfully read.
			// set the flag as visible or not, depending on the results.
			const dataLayer = this.dataLayerService.getDataLayerDetails ( 'allStations' );
			self.stationsObservable = dataLayer.valueObservable.asObservable();
			self.stationsObservable.subscribe ( stations => {
				console.log("stations have been read");
				this.configService.setDisplayWaitDialog(false);
				if ( stations != null ) {
					// console.log('Clearing error flag.');
					self.setErrorFlag(self.allStationsError, false);
					$('#stationSummaryGroup').css('cursor', 'default' );
					$('#stationDashboardGroup').css('cursor', 'default' );
					$('#customDashboardGroup').css('cursor', 'default' );
					/* if you wanted to view the wait dialog, uncomment...
					const waitThingy = timer( 5000 );
					waitThingy.subscribe( x => { this.displayWaitDialog = false; }) ;
					*/
			} else {
					self.setErrorFlag(self.allStationsError, true);
					console.error('Failed to retrieve stations');
				}
			}, error => {
				this.configService.setDisplayWaitDialog(false);
				this.messageService.add({severity: 'error', summary: error.status + ' Data Web Services Error',
					detail: error.detail });
			});
			this.summaryTooltip="A color and corresponding number is shown reflecting the number of stations not reporting (black), out of service (blue), and for each NovaScore.";
			// console.log ( dataLayer );
	
	}

	ngOnInit() {
		this.primeng.ripple.set(true);

		// check if login is required
		if ( this.configService.checkIfGuestAllowed() === true ) {
			this.configService.setUserName (this.userName, '').subscribe(() => {
				console.log('Called setUserName');
				this.finishInit();
			});
		} else {
			// login is required
			this.configService.verifyCredentials();
			this.authService.isLoggedInObservable.pipe(takeWhile ( isLoggedIn => isLoggedIn == false ))
				.subscribe({
					next: value => console.log(value),
					complete: () => { this.finishInit()}
				})
		}

		/*
		I believe HashLocationStrategy makes subscribing to the route queryParams not possible
		Must use location.path instead.  If queryParameters are included, will have to parse them
		out - ugly.
        this._route.queryParams.subscribe ( queryParams => { 
			console.log(queryParams);
		});
		*/
	}

	ngAfterViewInit() {
		// Remember that this is called after components have been created, but configService and mapService may still be doing
		// asynchronous work.  So that data won't yet be available.
		console.log("In app.component.ngAfterViewInit");
		this.checkDisclaimerApprovalRequired(false);
	}

	finishInit() {
		const path = this.location.path(false);

		if ( path === '') {
			console.log("Found path empty");
			this._router.navigate(['/map']);
		} 

		this.createOverlayLayersDefinitions ();
		this.setClientLogo();
		this.configService.setupUser();
		this._dataLayerService.processAdditionalDataDisplayLayers();
		this.confirmationCBTextDoNotShow = this.appConfigService.getDisclaimerRead();
		this.cookiesOK = this.appConfigService.getCookiesAcknowledged();
		console.log("CookiesOK: " + this.cookiesOK );

	}

	// just in case users have Hash in path, redirect to PathLocationStrategy
	/*
	private redirectHashURLToPath(): void {
		this._router.events.subscribe(event => {
			if ( event instanceof NavigationEnd) {
				if (!!event.url&& event.url.match(/^\/#/)) {
					this._router.navigateByUrl(event.url.replace('/#', ''));
				}
			}
		})
	}
	*/

	// only allow queryParam "config"
	goToRouterLink(linkString: string) {
		this.appConfigService.goToRouterLink(linkString);
	}

	// Retrieves the logo specified in the configuration file.
	// If a file has been specified and it exists, assign to clientLogo and set clientLogoExists to true.
	// Otherwise, set clientLogoExists to false which will set that image to not display through css.
	setClientLogo () {
		this.clientLogo = this.appConfigService.getClientLogoURL();
		this.clientWebsite = this.appConfigService.getClientWebsite();
		if ( this.clientLogo === '') {
			this.clientLogoExists = false;
			console.log ('No client logo specified.');
		} else {
			// Call http.head rather than get since the file could be huge and we aren't really interested
			// in the content of the file, just whether it exists or not.
			this.http.head(this.clientLogo, { observe: 'body', responseType: 'blob'})
				.subscribe(
					data => { this.clientLogoExists = true; console.log('Client logo found:', this.clientLogo ); },
					error => { this.clientLogoExists = false; console.log('Client logo not found:', this.clientLogo ); }
				);
		}

	}

	// If the nsoperator-config.json file includes "OperatorInterface.disclaimerApprovalRequired: true"
	// a confirmation dialog is displayed.
	// force, when true, will force the dialog to display whether the user has previously read it or not,
	// allowing the user to make different choices.
	checkDisclaimerApprovalRequired(force: boolean) {
		console.log('Disclaimer required: ' + this.appConfigService.isDisclaimerApprovalRequired());
		if (  force || 
			( this.appConfigService.isDisclaimerApprovalRequired() && !this.appConfigService.getDisclaimerRead()) ) {
			console.log("Displaying disclaimer.");
			this.dataWebServices.getService('version').subscribe ({
				next: result => {
					this.providerOrganizationText = result?.attributionAndUsage?.providerOrganizationText || 
						"Welcome";
					this.disclaimerText = result?.attributionAndUsage?.disclaimerText || 
						"This organization makes no warranty, expressed or implied, regarding the accuracy of the data.";

					this.confirmationDialogVisible = true;
				}
			})
		}
	}

	closeConfirmationDialog() {
		this.confirmationDialogVisible = false;
		if ( this.cookiesOK ) {
			this.appConfigService.setCookiesAcknowledged(this.cookiesOK);
			if ( this.confirmationCBTextDoNotShow == true ) {
				this.appConfigService.setDisclaimerRead();
				}
		} else {
				this.appConfigService.clearCookies();
		}
	}

	enableConfirmationOK() {
		this.confirmationDialogDisabled = false;
	}

	// This routine intercepts, processes and then passes on the console output.
	// The main problem is that the originating function and line number of the message is lost.
	takeOverConsole() {
		const original = window.console;
		function handle(method, args) {
			const message = Array.prototype.slice.apply(args).join(' ');
			// do sneaky stuff
			if (original) { original[method](message); }
		}
		(<any>window).console = <Console>({
			log: function() {
				handle('log', arguments);
			}
			, warn: function() {
				handle('warn', arguments);
			}
			, error: function() {
			handle('error', arguments);
			}
		});
	}

	// Once the user have been identified, do all configuration and data reading steps.
	public initializeBasedOnLogin() {
		const self = this;
		this.userName = this.configService.userName;
		console.log('Initializing based on login: ' + this.userName);
		if ( this.userName !== 'guest' ) {
			this.userLoggedIn = true;
		}

		this.createBackgroundLayers();
		this.createDashboardTemplateDefinitions ();

		// initial parse of novastar data
		this.setSelectionCursorsToWait();
		this.refreshDataAndTime(false);

		// now set up the timer to display data and time on a 5-minute interval
		const delay = this.calculateDelayToUpdate();
		const dataUpdateInterval = 
			this.configService.getDataUpdateInterval();

		/// console.log(dataUpdateInterval);
		// this.timeIntID = Observable.timer( delay, dataUpdateInterval );  // 300000 = 5 minute timer
		// just in case there is already a timer going, unsubscribe
		if ( this.timeIntIDSubscription != null ) {
			this.timeIntIDSubscription.unsubscribe();
		}
		this.timeIntID = timer( delay, dataUpdateInterval );  // 300000 = 5 minute timer
		this.timeIntIDSubscription = this.timeIntID.subscribe( x => {
			console.log("Auto refreshing");
			this.refreshDataAndTime(true);
		});
	}

	displayVersion() {
		alert('Novastar Operator Interface: ' + this.version);
	}

	// Refreshes the date string on the top navbar of GUI
	// as well as rereads all the NovaStar data
	// In order to know whether refreshDataAndTime and consequently parseAndDisplayData and activate Layer has been called as
	// the result of initialization or a user action OR the automatic 5-minute update, include parameter 'autoRefresh'
	refreshDataAndTime(autoRefresh) {
		// console.log("In refreshDataAndTime");
		this.displayTime( new Date());
		this.parseAndDisplayData(autoRefresh);
	}

	// parseAndDisplayData is a workhorse.  It spawns all the routines which read data.  However, it could be called upon
	// initialization or when the refresh has happened to reread data.  For some data types that require more time to read,
	// the cursor is set to "wait" and then changed to "default" upon completion or error.
	parseAndDisplayData (autoRefresh) {
		console.log("In parseAndDisplayData");
		// console.log(this._route.url);

		// First figure out which data display layers radio button is currently selected.  This is useful
		// because if parseAndDisplayData was called due to a periodic refresh event,
		// the currently selected layer should be redrawn in case NovaScores have changed.
		const checkedDataDisplayLayer = $('input[name=optradio]:checked').val();
		// console.log(checkedDataDisplayLayer);  // will be undefined upon initial read

		const self = this;

		this._dataLayerService.parseAllStationsObservable();

		// parse flood impact stations
		if ( this.appConfigService.getDisplayFloodImpactOnMap() || this.appConfigService.getDisplayFloodImpactSummary() ) {
			this._dataLayerService.parseAllFloodImpactStations();  // should I move parseAllFloodImpactStations to return a promise?
		}


		// 
		// Call data web service to retrieve all stations in geojson format.  Then call each layer to process
		// for unique data types.
		//
		this._dataLayerService.retrieveAllStationsGeojson()
		.then (function(response) {
			self.allStationsGeojson = response;

			//
			// parse stage/water level stations
			//
			self._dataLayerService.parseDataLayersWaterLevelRiver(self.allStationsGeojson).then (function(response) {
				// set the number of stations for each novastar value which get displayed on the GUI
				self.setErrorFlag(self.stageError, false);
				self.stageCounts = self._dataLayerService.getStageCounts();
				// if this happened during a periodic refresh, redraw the layer if it was active
				if ( checkedDataDisplayLayer === 'stageRadio' ) {
					self.mapService.deactivateLayer('waterLevelStations');
					self.mapService.activateLayer('waterLevelStations', autoRefresh);
				}
				$('#stageRadio').css('cursor', 'default' );
			}, function(error) {
			});

			//
			// parse flow/discharge stations
			//
			self._dataLayerService.parseDataLayersDischargeRiver(self.allStationsGeojson).then (function(response) {
				// console.log(response);
				// set the number of stations for each novastar value which get displayed on the GUI
				self.setErrorFlag(self.flowError, false);
				self.flowCounts = self._dataLayerService.getFlowCounts();
				// if this happened during a periodic refresh, redraw the layer if it was active
				if ( checkedDataDisplayLayer === 'flowRadio' ) {
					self.mapService.deactivateLayer('streamFlowStations');
					self.mapService.activateLayer('streamFlowStations', autoRefresh);
				}
				$('#flowRadio').css('cursor', 'default' );
			}, function(error) {
				self.setErrorFlag(self.flowError, true);
				console.error('Failed', error);
			});

			//
			// parse precip stations
			//
			self.parseAndDisplayPrecip (self.allStationsGeojson, (checkedDataDisplayLayer === 'precipitationRadio') ? true : false, autoRefresh);

		}, function(error) {
				self.setErrorFlag(self.stageError, true);
				console.error('Failed', error);
		})
		.catch(err => {
			self.setErrorFlag(self.stageError, true);
			console.error('Failed', err);
			alert('Data Web Services failed to return NovaStar data.  Please contact technical support.');
		});

		if ( checkedDataDisplayLayer === 'addnlDataRadio' ) {
			self.mapService.deactivateLayer('addnlData');
			self.mapService.activateLayer('addnlData', autoRefresh);
			$('#flowRadio').css('cursor', 'default' );
		}


		//
		// parse flood impact stations
		//

		if ( this.appConfigService.getDisplayFloodImpactOnMap() ) {
			this._dataLayerService.parseDataLayersFloodImpact().then (function(response) {

				// does the user want to see flow or capacity
				self.setDesiredFloodImpactTitle();

				// set the number of stations for each novastar value which get displayed on the GUI
				self.setErrorFlag(self.fitError, false);
				self.fitCounts = self._dataLayerService.getFITCounts();
				// if this happened during a periodic refresh, redraw the layer if it was active
				if ( $('#toggleFloodImpact').prop('checked') ) {
					self.mapService.deactivateLayer('fitAssetsGeoJSON');
					self.mapService.activateLayer('fitAssetsGeoJSON', autoRefresh);
				}
				self.fillBoundingBoxSelections('fitAssetsGeoJSON');
				$('#toggleFloodImpact').css('cursor', 'default' );
			}, function(error) {
				self.setErrorFlag(self.fitError, true);
				// console.error('Failed', error);
			});
		}

		this.parseAndDisplayOverlayLayers();

	}

	// The user has changed the value in the search input
	// Update the status on the number of matches for each Data Display Layer
	updateSearchItemMatches(searchString) {
		console.log('Need to update number of matches for: ' + searchString);
		const searchStringAllCaps = searchString.toUpperCase();

		if ( searchString === '') {
			this.numMatchingPrecipStations = 0;
			this.numMatchingStageStations = 0;
			this.numMatchingStreamflowStations = 0;
			return;
		}

		// search all data layers for precip, stage and flow and update status values
		this.dataLayerService.getDataLayers().then(dataLayers => {
			// console.log(this);
			// console.log(dataLayers);
			dataLayers.forEach(function(item) {
				// search value for id or name contains searchBoxString
				// if mataches, add it to the array of features to highlight
				if (item.dataType === 'streamFlowStations') {
					const matchingFeatures = item.value.features.filter ( feature => {
						return ('' + feature.properties.stationSummary.numId).includes(this.searchString) ||
								feature.properties.stationSummary.name.toUpperCase().includes(searchStringAllCaps);
					});
					this.numMatchingStreamflowStations = matchingFeatures.length;
				} else if (item.dataType === 'waterLevelStations') {
					const matchingFeatures = item.value.features.filter ( feature => {
						return ('' + feature.properties.stationSummary.numId).includes(this.searchString) ||
								feature.properties.stationSummary.name.toUpperCase().includes(searchStringAllCaps);
					});
					this.numMatchingStageStations = matchingFeatures.length;
				} else if (item.dataType === 'precipStations') {
					const matchingFeatures = item.value.features.filter ( feature => {
						return ('' + feature.properties.stationSummary.numId).includes(this.searchString) ||
								feature.properties.stationSummary.name.toUpperCase().includes(searchStringAllCaps);
					});
					this.numMatchingPrecipStations = matchingFeatures.length;
				}
			}, this);

		});
	}

	// refresh each overlay layer
	// because each layer checks checks whether it's active and whether the data should be reread,
	// simply calling refreshLayer is necessary
	parseAndDisplayOverlayLayers() {
		this.dataLayerService.getDataLayers().then ( dataLayers => {
			dataLayers.forEach(function(item) {
				if ( item.dataType === 'dynamicOverlayLayer' ) {
					item['component'].instance.refreshLayer();
				}
			});
		});
	}

	parseAndDisplayAddnlLayer() {
		console.log("In parseAndDisplayAddnlLayer")	;
		this._dataLayerService.parseAdditionalDataLayers( ).then ( x => {
			this.mapService.activateLayer('addnlData', false);
		});
	}

	// parseAndDisplayPrecip accepts a boolean to indicate whether to activate the layer.  This is useful because if this
	// routine is called upon initial reading of data, the precip layer is not intended to refresh.  However, if the user
	// clicked on the precip interval pulldown to get here, we do want to display the precip layer.
	parseAndDisplayPrecip (allGeojsonStations, activate: boolean, autoRefresh) {
		const self = this;
		// If initializing, set the precip as active layer by default.
		if ( self.initializingOperator ) {
			self.initializingOperator = false;
			activate = true;
			$('#precipitationRadio').prop('checked', true);
		}
		const rainfallInterval = this._dataLayerService.rainfallInterval;

		this._dataLayerService.parseDataLayersPrecip(allGeojsonStations, rainfallInterval).then (function(response) {
			// console.log(response);
			// set the number of stations for each novastar value which get displayed on the GUI
			self.setErrorFlag(self.precipError, false);
			self.precipCounts = self._dataLayerService.getPrecipCounts();

			// if this routine was called because the user wants to view precip stations,
			// deactive all other data display layers and activate precip
			if ( activate ) {
				self.mapService.deactivateLayer('streamFlowStations');
				self.mapService.deactivateLayer('waterLevelStations');
				self.mapService.deactivateLayer('precipStations');
				self.mapService.activateLayer('precipStations', autoRefresh);
				console.log(self._dataLayerService.rainfallInterval);
			}
			$('#precipitationRadio').css('cursor', 'default' );
			$('#rainfallDataType').css('cursor', 'default' );
		}, function(error) {
			console.error('Failed', error);
			self.setErrorFlag(self.precipError, true);
		});
	}

	// The user may wish to see either flow or capacity on the marker for flood impact.
	// The entire layer doesn't need to be reread, just the data layer title respecified (fitTitle=flow, capacity=capacity).
	// This function should be called before activating the layer
	setDesiredFloodImpactTitle ( ) {
		const dataLayer = this.dataLayerService.getDataLayerDetails('fitAssetsGeoJSON');
		if ( $('#fitDisplayFlow').prop('checked') ) {
			dataLayer.title = 'fitTitle';
		} else { // capacity
			dataLayer.title = 'capacity';
		}
	}

	// Calculate the delay until the timer starts.
	// Want to set it to every whole 5 minutes, i.e. 9:45, 9:50, ... not 9:43, 9:48, ...
	// If delta between current time and whole 5 minute mark is < 2 minutes, wait 5 minutes + delta.
	// If delta between current time and whole 5 minute mark is > 2 minutes, set update to next 5 minute mark.
	calculateDelayToUpdate() {
		const c5minutes = 1000 * 60 * 5;
		const c2minutes = 1000 * 60 * 2;
		const date = new Date();
		const currentms = date.getTime();
		let futurems = Math.ceil(currentms / c5minutes) * c5minutes;
		futurems = ( futurems - currentms < c2minutes ) ? ( futurems + c5minutes ) : futurems;
		// console.log(futurems - currentms);
		return futurems - currentms;
		// return 0; // for no delay but not what we want
	}

	// displays the date (d) parameter in the top bar of the interface
	displayTime (m) {
		this.timeLabel = m.toLocaleString();
		// this.timeLabel = (m.getUTCMonth()+1) +"/"+ m.getUTCDate() + "/" + m.getUTCFullYear() + " " + m.getUTCHours() + ":" + m.getUTCMinutes();
		// d.toLocaleString();

	}

	// setErrorFlag sets the flagVariable (fitError, precipError, stageError, etc. to flag
	// If any of the data type variables are true (there is at least 1 error), the errorVisible is set to true.
	// This indicates to the interface whether to show the error image or not.
	setErrorFlag ( flagVariable, flag ) {
		// console.log( flag );
		flagVariable = flag;

		if ( this.fitError || this.precipError || this.stageError || this.flowError || this.allStationsError || this.floodImpactStationsError ) {
			this.errorVisible = true;
		} else {
			this.errorVisible = false;
		}
	}


	// mapService's baseMaps, which are defined dynamically, are used to create the Background Layers radio buttons.
	// This routine creates and inserts the html necessary, including setting the class to dynamicBaseLayer which is used
	// in a click event of those radio buttons.
	createBackgroundLayers () {
		const div = document.getElementById('BackgroundLayers');
		if ( div == null ) return;

		// remove any existing background layers
		// this only comes into play if users hit refresh and
		// a new login is performed behind the scene
		while (div.hasChildNodes()) {
			div.removeChild(div.lastChild);
		}

		// populate background layers GUI selections
		for ( const prop in this.mapService.baseMaps ) {
			if ( this.mapService.baseMaps.hasOwnProperty(prop)) {
				let propNoSpaces = prop.split(' ').join('');
				const radioHTML =
				'<div class="radio">' +
					'<label class="dynamicBaseLayer" id="' + prop + '">' +
						'<input type="radio" name="backgroundradio" id="' + propNoSpaces + 'Radio" (click)="menuControlSelected($event)">' + prop + '</label></div>';
				div.insertAdjacentHTML('beforeend', radioHTML );
			}
		}

		// set the initial background layers radio selection box
		// console.log(this.mapService.getActiveTileLayerName());
		$('#' + this.mapService.getActiveTileLayerName() + 'Radio').prop('checked', true);
	}

	// Given the definition of the overlay layers, set up the framework by adding each layer to the dataLayerDetails array.
	// For each overlayLayer, the factory creates the appropriate component, adds it to the view location, customizes it through
	// the setData routine for that component, and adds it ot our list of layers within dataLayerService.
	 processAdditionalDataDisplayLayers() {
		// Catherine - This is a bit of a cheat.  It allows access to dataLayerService since config service can't
		// directly call dataLayerService when reading a secondary file.  
		// In the future, perhaps rewrite so there is a listener for when the configuration file changes and all 
		// dependents can update automatically.
		this._dataLayerService.processAdditionalDataDisplayLayers();
	 }
	createOverlayLayersDefinitions () {
		if ( this.dataLayerHost != null ){

		const overlayLayers = this.configService.getOverlayLayers();

		// clear out any previously defined overlay layers first
		this.dataLayerService.clearDynamicOverlayLayers();
		this.dataLayerHost.viewContainerRef.clear();

		console.log("Creating new overlay layers: ", overlayLayers);

		// create new layers
		overlayLayers.forEach(function(item) {
			const newComponent = this.createOverlayLayerComponent ( item.class );
			const factory = this.componentFactoryResolver.resolveComponentFactory(newComponent);
			const viewContainerRef = this.dataLayerHost.viewContainerRef;

			// console.log(factory);
			// console.log(viewContainerRef);

			// do not clear because all layers must be added
			// viewContainerRef.clear();

			const componentRef = viewContainerRef.createComponent(factory);
			// console.log(componentRef);

			// now customize our new overlay layer
			(componentRef.instance).setData(item);

			this.dataLayerService.getDataLayers().then ( dataLayers => {
				const newLayer = {
					'dataType': 'dynamicOverlayLayer',
					'component': componentRef
				};
				dataLayers.push ( newLayer );
			});

			/*  this works if you know the component class
			let componentFactory = this.componentFactoryResolver.resolveComponentFactory(DataLayerGeojsonCamerasComponent);
			let viewContainerRef = this.dataLayerHost.viewContainerRef;
			viewContainerRef.clear();
			let componentRef = viewContainerRef.createComponent(componentFactory);
			*/
			console.log('CREATING a new ' + item.class + ' component');

		}, this);
		 }

	}

	/*
	** Prior to ivy, the class name could directly create the component.  However, that has now changed,
	** so we must help the compiler make the connection between the class name and the class itself.
	*/
	createOverlayLayerComponent ( className ) {
			switch( className ) {
				case 'data-layer-ca-qpf': {
					return ( DataLayerCaQPFComponent );
				break;
				}
				case 'data-layer-cameras': {
					return ( DataLayerGeojsonCamerasComponent );
				break;
				}
				case 'data-layer-cameras-blueiris': {
					return ( DataLayerGeojsonCamerasBlueIrisComponent );
				break;
				}
				case 'data-layer-geojson-point': {
					return ( DataLayerGeojsonPointComponent );
				break;
				}
				case 'data-layer-geojson-polygon-point': {
					return ( DataLayerGeojsonPolygonPointComponent );
				break;
				}
				case 'data-layer-geojson-point-fhit': {
					return ( DataLayerGeojsonPointFHITComponent );
				break;
				}
				case 'data-layer-geojson-polygon': {
					return ( DataLayerGeojsonPolygonComponent );
				break;
				}
				case 'data-layer-geojson-point-links': {
					return ( DataLayerGeojsonPointLinksComponent );
				break;
				}
				case 'data-layer-geojson-point-dws': {
					return ( DataLayerGeojsonPointDWSComponent );
				break;
				}
				case 'data-layer-geojson-point-dws-repeater': {
					return ( DataLayerGeojsonPointDWSRepeaterComponent );
				break;
				}
				case 'data-layer-geojson-point-weather': {
					return ( DataLayerGeojsonPointWeatherComponent );
				break;
				}
				case 'data-layer-geojson-point-weather-station': {
					return ( DataLayerGeojsonPointWeatherStationComponent );
				break;
				}
				case 'data-layer-gif': {
					return ( DataLayerGifComponent );
				break;
				}
				case 'data-layer-kml-point': {
					return ( DataLayerKmlPointComponent );
				break;
				}
				case 'data-layer-wind': {
					return ( DataLayerGeojsonWindComponent );
				break;
				}
				case 'data-layer-png-rainviewer': {
					return ( DataLayerPNGRainviewerComponent );
				break;
				}
				case 'data-layer-tms': {
					return ( DataLayerTMSComponent );
				break;
				}
				case 'data-layer-wms': {
					return ( DataLayerWMSComponent );
				break;
				}
				case 'data-layer-wms-time': {
					return ( DataLayerWMSTimeComponent );
				break;
				}	
			}
	}


	// Given the definition of the dashboard templates,
	// set up the framework by adding each layer to the dashboardTemplateDetails array.
	// For each dashboard template, the factory creates the appropriate component,
	// adds it to the view location, customizes it through
	// the setData routine for that component, and adds it ot our list of templates
	// within dashboardTemplatesService.
	createDashboardTemplateDefinitions () {
		// First,  clear out existing templates and links to them:
		if ( this.dashboardTemplateHost != null ) {

		const viewContainerRef = this.dashboardTemplateHost.viewContainerRef;
		viewContainerRef.clear();
		this.dashboardTemplateService.clearDashboards();

		// Next, use dashboard template defined within the system configuration file.
		this.dashboardTemplateService.parseDataFile().subscribe ( 
			templateObject => {
				console.log(templateObject);
				templateObject.dashboardTemplates.forEach(function(item) {
					// add source to template - configuration file in this case
					item['source'] = 'Config';
					this.addDashboardTemplateDefinition ( item );
				}, this);
				this.dashboardTemplateService.setCustomDashboardProcessedTrue();
			},
			err => {
				console.log('Error reading custom template file.');
				// set processed to true regardless so user defined templates can still be used
				this.dashboardTemplateService.setCustomDashboardProcessedTrue();
			},
			() => {
				console.log('Completed attempt to read custom template file.');
			}
		);

		console.log ('About to check UWS user preferences.  Real user: ' + this.configService.isARealUser());
		if ( this.configService.isARealUser()) {
			console.log('Calling user web services using ' + this.userName);
			this.usersService.getUserPreferences(this.userName).subscribe( userProfile => {
				console.log(userProfile);
				const preferences = userProfile.preferences.preferences;
				// console.log(preferences);
				if ( preferences !== null && preferences.hasOwnProperty('dashboardTemplates')) {
					const templates = preferences.dashboardTemplates;
					// console.log(templates);
					templates.forEach(function(item) {
						// add source to template - configuration file in this case
						item['source'] = 'UWS';
						this.addDashboardTemplateDefinition ( item );
					}, this);
					this.dashboardTemplateService.setUserDashboardProcessedTrue();
				} else {
					this.dashboardTemplateService.setUserDashboardProcessedTrue();
				}
			});
		} else {
			this.dashboardTemplateService.setUserDashboardProcessedTrue();

		}
		}
	}

	// addDashboardTemplatedefinition adds the templateDetails to the list of templates
	// as well as adding it to the list of dashboards in the left menu.
	addDashboardTemplateDefinition (templateDetails) {
		const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DashboardTemplateLinkComponent);
		const viewContainerRef = this.dashboardTemplateHost.viewContainerRef;
		const componentRef = viewContainerRef.createComponent(componentFactory);

		// console.log(factory);
		// console.log(viewContainerRef);

		// do not clear because all templates must be added
		// viewContainerRef.clear();

		// now customize our new overlay layer
		(componentRef.instance).setData(templateDetails);

		const newDashboard = {
			'dataType': 'dynamicDashboardTemplate',
			'component': componentRef,
			'templateDetails': templateDetails
		};

		this.dashboardTemplateService.addTemplate(newDashboard);
	}

	// deleteDashboardTemplatedefinition deletes the templateDetails from the list of templates
	// as well as removing it from the list of dashboards in the left menu.
	deleteDashboardTemplateDefinition (templateIndex ) {
		if ( templateIndex != -1 ) {
			const viewContainerRef = this.dashboardTemplateHost.viewContainerRef;
			viewContainerRef.remove(templateIndex);
		}
	}

	// updateBackgroundLayersButton sets the radio selection box to match the currently active tile layer name.
	updateBackgroundLayersButton() {
		// set the initial background layers radio selection box
		console.log(this.mapService.getActiveTileLayerName());
		$('#' + this.mapService.getActiveTileLayerName() + 'Radio').prop('checked', true);
	}


	// boundingBoxSelected zooms the map via map services into the specified bounding box within the event
	boundingBoxSelected(dropdown): void {
		this.mapService.fitBounds();

		// unset the selected value so if it is selected again, the selection will be recognized
		// resetZoomSelection isn't clearing the dropdown
		// I don't know why - using updateSelectedOption
		this.mapService.resetZoomSelection();
		dropdown.updateSelectedOption(null);
	}

	// menuControlSelected is called every time a control is
	// selected on the menu div.  The entire event is passed
	// because different controls pass information through a
	// variety of targets.  The event is processed using the id
	// of the target component.
	menuControlSelected(event): void {
		console.log('Menu control selected: ', event);
		// console.log(this);
		switch (event.target.id) {
			case 'toggleLegend':
				this.mapService.toggleLegendMain();
				this.mapService.toggleShowLegend();
			break;
			case 'toggleFloodImpact':
				if ( event.target.checked ) {
					this.setDesiredFloodImpactTitle();
					this.mapService.activateLayer('fitAssetsGeoJSON', false);
				} else {
					this.mapService.deactivateLayer('fitAssetsGeoJSON');
				}
				this._dataLayerService.refreshLegendList();
			break;
			case 'fitDisplayFlow':
			case 'fitDisplayCap':
				// does the user want to see flow or capacity
				this.setDesiredFloodImpactTitle();

				if ( $('#toggleFloodImpact').prop('checked') ) {
					this.mapService.deactivateLayer('fitAssetsGeoJSON');
					this.mapService.activateLayer('fitAssetsGeoJSON', false);
				}
			break;

			default:
				console.log('No action assigned to this control yet.');
		}

	}

	// Either a radio button or dropdown within the 
	// Data Display Layers section clicked
	dataDisplayLayerClicked(id) {
		console.log('Data Layer clicked: ' + id);
		switch (id) {
			case 'precipitationRadio':
				this.mapService.deactivateLayer('streamFlowStations');
				this.mapService.deactivateLayer('waterLevelStations');
				this.mapService.deactivateLayer('precipStations');
				this.mapService.deactivateLayer('addnlData');
				this.mapService.activateLayer('precipStations', false);
				this._dataLayerService.refreshLegendList();
			break;
			case 'rainfallDataType':
				$('#precipitationRadio').prop('checked', true);
				this.parseAndDisplayPrecip(this.allStationsGeojson, true, false);
			break;
			case 'stageRadio':
				this.mapService.deactivateLayer('streamFlowStations');
				this.mapService.deactivateLayer('precipStations');
				this.mapService.deactivateLayer('waterLevelStations');
				this.mapService.deactivateLayer('addnlData');
				this.mapService.activateLayer('waterLevelStations', false);
				this._dataLayerService.refreshLegendList();
			break;
			case 'flowRadio':
				this.mapService.deactivateLayer('precipStations');
				this.mapService.deactivateLayer('waterLevelStations');
				this.mapService.deactivateLayer('streamFlowStations');
				this.mapService.deactivateLayer('addnlData');
				this.mapService.activateLayer('streamFlowStations', false);
				this._dataLayerService.refreshLegendList();
			break;
			case 'noDataLayerRadio':
				this.mapService.deactivateLayer('precipStations');
				this.mapService.deactivateLayer('waterLevelStations');
				this.mapService.deactivateLayer('streamFlowStations');
				this.mapService.deactivateLayer('addnlData');
				this._dataLayerService.refreshLegendList();
			break;
			case 'addnlDataRadio':
				this.mapService.deactivateLayer('precipStations');
				this.mapService.deactivateLayer('waterLevelStations');
				this.mapService.deactivateLayer('streamFlowStations');
				this.mapService.deactivateLayer('addnlData');
				this.parseAndDisplayAddnlLayer();
				this._dataLayerService.refreshLegendList();
			break;
			case 'addnlDataLayerDropdown':
				this.mapService.deactivateLayer('precipStations');
				this.mapService.deactivateLayer('waterLevelStations');
				this.mapService.deactivateLayer('streamFlowStations');
				this.mapService.deactivateLayer('addnlData');
				$('#addnlDataRadio').prop('checked', true);
				this.parseAndDisplayAddnlLayer();
			break;

			default:
				console.log('Unknown radio button clicked: ' + id );
		}
	}

	// sets the larger data set buttons to wait.
	// parseAndDisplayData will set it back to default after reading data.
	setSelectionCursorsToWait() {
		$('#precipitationRadio').css('cursor', 'wait' );
		$('#rainfallDataType').css('cursor', 'wait' );
		$('#stationDashboardGroup').css('cursor', 'wait' );
		$('#customDashboardGroup').css('cursor', 'wait' );
		$('#stationSummaryGroup').css('cursor', 'wait' );
		$('#flowRadio').css('cursor', 'wait' );
		$('#stageRadio').css('cursor', 'wait' );
		$('#toggleFloodImpact').css('cursor', 'wait' );
	}

	// fills the quickZoom selection box using data defined by bbox - currently only works for fitAssets layer
	// when bbox is defined in that data file
	fillBoundingBoxSelections (layerId) {
		this.mapService.setBasicZoomOptions();
		this.mapService.addLayerZoomOptions(layerId);
	}

	attachEvents() {
		window.onresize = () => {
			/*  This toggles the menu in and out on resize.  Why would that be desirable?
            if (this.getWidth() >= this.mobileView) {
                if (localStorage.getItem('toggle')) {
                    this.toggle = !localStorage.getItem('toggle') ? false : true;
                } else {
                    this.toggle = true;
                }
            } else {
                this.toggle = false;
            }
			*/
		};
	}

	getWidth() {
		return window.innerWidth;
	}

	// if parameter visible is true, set the quick zoom components visible
	// otherwise, hide the components
	setQuickZoomVisibility( visible: boolean ) {
		// console.log('Setting quickZoomVisible: ' + visible);
		this.quickZoomVisible = visible;
	}

	// toggle the boolean for toggling the sidebar
	toggleSidebar() {
		this.toggle = !this.toggle;

		// set the popup title for the menu based on whether it is displayed or hidden
		this.menuTitle = this.toggle === false ? 'Display view controls' : 'Hide view controls';

		localStorage.setItem('toggle', this.toggle.toString());
	}

	//
	// logout
	//
	logout() {
		console.log('Logging out');
		this.authService.logout();
		this.configService.setUserName('guest', '').subscribe();
		this.userLoggedIn = false;
	}

	//
	// login
	//
	login() {
		console.log('Going to login screen');
		this.authService.login();
	}
}


